var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpenInputreact = function SvgOpenInputreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 5",
    d: "M11.761 24.004v-7.545a7.52 7.52 0 0 0-3.953-4.2H0v-.513h7.809a7.5 7.5 0 0 0 3.952-4.2V.004h.483v7.545a7.505 7.505 0 0 0 3.95 4.2H24v.513h-7.807a7.513 7.513 0 0 0-3.95 4.2v7.542Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8989",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};

export default SvgOpenInputreact;